export const isGuid = (value) => {
  if (!value || typeof value !== 'string') {
    return false
  }

  const re = new RegExp(/^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i); 
  // const re = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i); 

  return re.test(value);
}

export function isNumeric(str) {
  if (typeof str !== "string") return false // we only process strings!
  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
         !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export const formatDate = (ISODate, format, timeZoneCode) => {
  if (!ISODate) {
    return ''
  }
  
  const date = new Date(ISODate)
  if (isNaN(date.valueOf())) {
    return ''
  }
  
  const dateTimeZoneString = date.toLocaleDateString('ru-RU', { timeZone: timeZoneCode, timeZoneName: 'long' })
  const [dateString, timeZoneShort, dst] = dateTimeZoneString.split(', ')
  // @ts-ignore Older types do not support 'longOffset' as a valid timeZoneName option, yet it is perfectly ok with our supported browsers
  const timeOffset = date.toLocaleDateString('ru-RU', { timeZone: timeZoneCode, timeZoneName: 'longOffset' }).split(', ')[1].slice(3)
  const timeString = date.toLocaleTimeString('ru-RU', { timeZone: timeZoneCode })
  const [day, month, year] = dateString.split('.')
  const [hours, minutes, seconds] = timeString.split(':')
  const timeZone = [timeZoneShort, dst].filter(p => !!p).join(', ')

  return format
    .replace('dd', day )
    .replace('mm', month )
    .replace('yyyy', year )
    .replace('MM', minutes )
    .replace('hh', hours )
    .replace('ss', seconds )
    .replace('tzs', timeZoneShort)
    .replace('tzo', timeOffset)
    .replace('tz', timeZone)
}